import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@1bill-app/pipes/pipes.module';
import { UpcomingBillsComponent } from './upcoming-bills.component';
import { BillBlockSingleComponent } from './bill-block-single/bill-block-single.component';
import { FormsModule } from '@angular/forms';

const COMPONENTS = [
  UpcomingBillsComponent,
  BillBlockSingleComponent,
];
@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    PipesModule,
    FormsModule,
  ],
  declarations: [...COMPONENTS],
  entryComponents: [],
  exports: [...COMPONENTS],
})
export class UpcomingBillsModule { }
